export enum DocumentTypeEnum {
  INVOICE = 'INVOICE',
  KYC = 'KYC',
}

export enum DocumentStatusEnum {
  PROCESSING = 'PROCESSING',
  UPLOADED = 'UPLOADED',
  FAILED = 'FAILED',
}

export enum DispositionEnum {
  INLINE = 'inline',
  ATTACHMENT = 'attachment',
}

export type ContractorDocument = {
  id: string;
  filename: string;
  status: DocumentStatusEnum;
  type: DocumentTypeEnum;
};
